import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const SINGLE_TWEET_PATTERN =
	/^https?:\/\/twitter\.com\/(.*?)\/status(es)?\/(\d+)+(\/(.)*)?(\?(.)*)?/;
const WIDGET_PATTERN = /https?:\/\/twitter\.com\/settings\/widgets\/(\d+).*$/;

export const matchTwitter: ProviderMatcher = (url, params) => {
	const widgetMatch = WIDGET_PATTERN.exec(url);
	if (widgetMatch) {
		return {
			kind: 'twitter-widget',
			provider: 'Twitter',
			embedUrl: url,
			width: withUnit(params.width) ?? '',
			height: withUnit(params.height) ?? '',
			widgetId: widgetMatch[1],
		};
	}
	if (SINGLE_TWEET_PATTERN.test(url)) {
		return {
			kind: 'twitter-widget',
			provider: 'Twitter',
			embedUrl: url,
			width: withUnit(params.width) ?? '',
			height: withUnit(params.height) ?? '',
		};
	}
	return null;
};
